import * as React from 'react';
import { useMutation, useQuery, useQueryClient } from 'react-query';
import { useTranslation } from 'react-i18next';
import { Form, Input, useForm, useNotify } from 'ebs-design';
import { ValidationError } from 'errors';
import { SmartSelect } from '../../../components/organisms';
import { listTransformResults } from '../../../utils';
import { useRegionsAPI } from '../../../api';

interface NomenclaturesFormToProps {
  id?: number;
  formId: string;
  getItem: any;
  onFinish: any;
  onClose: () => void;
}

export const FormNomenclaturesCities: React.FC<NomenclaturesFormToProps> = ({
  id,
  getItem,
  formId,
  onFinish,
  onClose,
}) => {
  const { t } = useTranslation();
  const notify = useNotify();
  const queryClient = useQueryClient();
  const [form] = useForm();

  const { getRegionsList } = useRegionsAPI();

  const { data } = useQuery([formId, { id }], getItem);

  React.useEffect(() => {
    if (data) {
      form.setFieldsValue(data);
    }
  }, [data]);

  const mutation = useMutation(onFinish, {
    onError: (e) => {
      if (e instanceof ValidationError) {
        form.setFields(e.fields);
      } else {
        notify.error({ title: t('error.someThingIsWrong') });
        onClose();
      }
    },
    onSuccess: () => {
      queryClient.invalidateQueries([formId]);
      onClose();
      notify.success({ title: t('success.successDataSave') });
    },
  });

  const handleSubmit = (): void => {
    mutation.mutate({ ...form.getFieldsValue(), id });
  };
  return (
    <Form id={formId} form={form} onFinish={handleSubmit}>
      <Form.Field name="name" label={t('nomenclature.name')}>
        <Input type="text" />
      </Form.Field>
      <Form.Field name="region" label={t('contacts.region')}>
        <SmartSelect
          search
          queryKey="regions"
          api={getRegionsList}
          placeholder={t('contacts.region')}
          transform={listTransformResults}
        />
      </Form.Field>
    </Form>
  );
};
